<template>
  <template v-if="dataReady">
    <!-- <h1>{{ source }}</h1> -->
    <Video
      :videoUrl="`${source}`"
      :h="`${height}`"
      :w="`${width}`"
      @ready="handleReady"
      @end="handleEnd"
      @start="handleStart"
    />
    <p>Assista o vídeo até o fim e tenha acesso a internet gratuita</p>
  </template>
  <template v-else>
    <h1>Loading</h1>
  </template>
</template>

<script>
import { ref } from "vue";
import { useRoute } from "vue-router";
import Video from "../components/Video.vue";
import { initializeApp } from "firebase/app";
import {
  getStorage,
  ref as fsRef,
  getDownloadURL,
  uploadBytes,
} from "firebase/storage";
import { getAnalytics, logEvent } from "firebase/analytics";

import { getCampaignByIdPromise, traffic } from "../services/api";

export default {
  name: "video-page",
  components: {
    Video,
  },
  data() {
    return {
      campaignId: this.$route.params.campaignId,
      route: useRoute(),
      width: 531,
      height: 945,
      dataReady: false,
      source: null,
      trafficId: '',
      traffic: {
        video_complete: false,
        video_start: false,
        page_view: true,
        utm_content: "",
        utm_term: "",
        utm_source: "",
        utm_campaign: "",
        utm_medium: "",
        campaignId: this.$route.params.campaignId
      }
    };
  },
  mounted() {
    console.log("mounted /video");
    getCampaignByIdPromise(this.route.params.campaignId)
      .then((data) => {
        this.campaignName = data.campaign.name;
        logEvent(this.analytics, "page_view", {
          campaign: data.campaign.name,
          source: "dado_global", //TODO: venueId
          page_path: data.campaign.name,
          page_title: data.campaign.name,
        });
        console.log("yep");
        console.log({ campaign: data });
        this.source = data.video.youtube_url;
        this.setVideoSizes(data.video.width, data.video.height);
        this.dataReady = true;
      })
      .catch((error) => {
        console.log(error);
      });
      traffic(this.trafficId, this.traffic)
      .then((data) => {
        this.trafficId = data.trafficId
      })
      .catch(error => console.log(error))
  },
  methods: {
    handleReady() {
      console.log("ready");
      logEvent(this.analytics, "video_ready", {
        campaign: this.campaign,
        source: "dado_global", //TODO: venueId
        page_path: this.campaign,
        page_title: this.campaign,
      });
      // alert("Assista o vídeo até o fim e tenha acesso a internet gratuita")//async
      logEvent(this.analytics, "click", {
        campaign: this.campaign,
        source: "dado_global", //TODO: venueId
        page_path: this.campaign,
        page_title: this.campaign,
      });
    },
    handleStart() {
      console.log("start");
      logEvent(this.analytics, "video_start", {
        campaign: this.campaign,
        source: "dado_global", //TODO: venueId
        page_path: this.campaign,
        page_title: this.campaign,
      });
      this.traffic.video_start = true
      traffic(this.trafficId, this.traffic)
      .then((data) => {
        this.trafficId = data.trafficId
      })
      .catch(error => console.log(error))
    },
    handleEnd() {
      console.log("ended");
      logEvent(this.analytics, "video_complete", {
        campaign: this.campaign,
        source: "dado_global", //TODO: venueId
        page_path: this.campaign,
        page_title: this.campaign,
      });
      this.traffic.video_complete = true
      traffic(this.trafficId, this.traffic)
      .then((data) => {
        this.trafficId = data.trafficId
      })
      .catch(error => console.log(error))
      window.location.href =
        "https://guestwifi-br.skyfii.com/engagement/complete2";
      return false;
    },
    setVideoSizes(wV0, hV0) {
      let hV1 = hV0;
      let wV1 = wV0;
      /* eslint-disable */
      while (window.innerWidth < wV0 || window.innerHeight < hV0) {
        if (window.innerHeight < window.innerWidth) {
          if (window.innerHeight < hV1) {
            hV1 = hV1 * (95 / 100);
            wV1 = wV1 * (95 / 100);
            continue;
          }
          break;
        } else {
          if (window.innerWidth < wV1) {
            hV1 = hV1 * (95 / 100);
            wV1 = wV1 * (95 / 100);
            continue;
          }
          hV1 = hV1 * (95 / 100);
          wV1 = wV1 * (95 / 100);
          break;
        }
      }
      while (window.innerWidth > wV0 || window.innerHeight > hV0) {
        if (window.innerHeight < window.innerWidth) {
          if (window.innerHeight > hV1) {
            hV1 = hV1 * (105 / 100);
            wV1 = wV1 * (105 / 100);
            continue;
          }
          hV1 = hV1 * (95 / 100);
          wV1 = wV1 * (95 / 100);
          break;
        } else {
          if (window.innerWidth > wV1) {
            hV1 = hV1 * (105 / 100);
            wV1 = wV1 * (105 / 100);
            continue;
          }
          hV1 = hV1 * (90 / 100);
          wV1 = wV1 * (90 / 100);
          break;
        }
      }
      this.height = parseInt(hV1);
      this.width = parseInt(wV1);
    },
  },
  setup() {
    const route = useRoute();
    
    const firebaseConfig = {
      apiKey: process.env.VUE_APP_API_KEY,
      authDomain: process.env.VUE_APP_AUTH_DOMAIN,
      projectId: process.env.VUE_APP_PROJECT_ID,
      storageBucket: process.env.VUE_APP_STORAGE_BUCKET,
      messagingSenderId: process.env.VUE_APP_MESSENGER_SENDER_ID,
      appId: process.env.VUE_APP_APP_ID,
      measurementId: process.env.VUE_APP_MEASUREMENT_ID,
    };
    const firebaseApp = initializeApp(firebaseConfig);

    // Initialize Analytics and get a reference to the service
    const analytics = ref(getAnalytics(firebaseApp));

    // Get a reference to the storage service, which is used to create references in your storage bucket
    const storage = getStorage(firebaseApp);

    let accessData = {
      venueId: "",
      deviceId: "",
      regId: "",
      time: new Date().toString(),
    };

    if (route.query.venueId) accessData.venueId = route.query.venueId;
    if (route.query.deviceId) accessData.deviceId = route.query.deviceId;
    if (route.query.regId) accessData.regId = route.query.regId;

    getDownloadURL(fsRef(storage, "userAccess.json"))
      .then((url) => {
        // This can be downloaded directly:
        const xhr = new XMLHttpRequest();
        xhr.responseType = "json";
        xhr.onload = () => {
          const usersData = xhr.response;
          usersData.push(accessData);
          var jsonString = JSON.stringify(usersData);
          var blob = new Blob([jsonString], { type: "application/json" });
          var accessDataRef = fsRef(storage, "userAccess.json");

          // 'file' comes from the Blob or File API
          uploadBytes(accessDataRef, blob).then((snapshot) => {
            console.log(snapshot);
          });
        };
        xhr.open("GET", url);
        xhr.send();
      })
      .catch((error) => {
        console.log(error);
        // Handle any errors
      });
    return {
      analytics,
    };
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
